import { all, put } from 'redux-saga/effects'

import {
  getCampaignsList,
  getCampaignsTiktokList,
  setCampaigns,
} from 'Redux/actions/campaignActions'
import {
  CampaignPlatformTypeEnum,
  SpotifyCampaign,
  TiktokCampaign,
} from 'Types/index'

// @ts-ignore
function* onGetCampaignsLists() {
  const [spotifyData, tiktokData] = yield all([
    put.resolve(getCampaignsList()),
    put.resolve(getCampaignsTiktokList()),
  ])

  const spotifyCampaigns: Array<SpotifyCampaign> = spotifyData?.payload
    ? // eslint-disable-next-line @typescript-eslint/no-explicit-any
      spotifyData?.payload.map((campaign: any) => ({
        id: campaign.id,
        type: campaign.type,
        trackCoverUrl: campaign.Track.track_image,
        trackTitle: campaign.Track.track_name,
        trackId: campaign.Track.track_id,
        trackAuthorName: campaign.Track.artist_name,
        startDate: campaign.start_date,
        endDate: campaign.end_date,
        status: campaign.status,
        is_feed: campaign.is_feed,
        platformType: CampaignPlatformTypeEnum.SPOTIFY,
        relaunched: campaign.relaunched,
        createdAt: campaign.created_at,
        reviewedReviews: campaign.reviewed_reviews,
        allReview: campaign.all_review,
      }))
    : []

  const tiktokCampaigns: Array<TiktokCampaign> = tiktokData?.payload?.campaigns
    ? // eslint-disable-next-line @typescript-eslint/no-explicit-any
      tiktokData?.payload?.campaigns.map((campaign: any) => ({
        id: campaign.id,
        type: null,
        trackCoverUrl: campaign.trackCoverUrl,
        trackTitle: campaign.trackTitle,
        trackAuthorName: campaign.trackAutorName,
        startDate: campaign.startDate,
        endDate: campaign.endDate,
        status: campaign.status,
        platformType: CampaignPlatformTypeEnum.TIKTOK,
        createdAt: campaign.created_at,
      }))
    : []

  const campaigns: Array<SpotifyCampaign | TiktokCampaign> = [
    ...spotifyCampaigns.sort(
      // @ts-ignore
      (a, b) => new Date(b.createdAt) - new Date(a.createdAt)
    ),
    ...tiktokCampaigns,
  ]

  yield put(setCampaigns(campaigns))
}

export default onGetCampaignsLists
